import { Option, Clazz, SelectedClass, IExemptionForm } from 'kuaidong-model'
import { AClazz } from 'kuaidong-api'
export class ExemptionService {
  public static initForm(): IExemptionForm {
    return {
      user_id: '',
      type: 'personal',
      start_time: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString(),
      end_time: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString(),
      attachments: [],
    }
  }

  public static async getSudentsOptions(
    clazzes: Clazz[],
    seletedclazz: SelectedClass
  ): Promise<Option<string>[] | undefined> {
    const c: Clazz | undefined = clazzes.find((c) => {
      return c.grade_no === seletedclazz.gradeNo && c.class_no === seletedclazz.classNo
    })
    if (c) {
      const cDetails: Clazz = await AClazz.findById(c.id)
      if (cDetails) {
        return cDetails!.students.map((s) => {
          return {
            value: s.user_id,
            label: (s.note_name ? s.note_name : s.full_name ? s.full_name : s.nick_name) as string,
          }
        })
      }
    }
  }
}
